import { Link, Navigate, useParams } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";
import { EXPERIENCES, CONTACT } from "../data/content";
import { track } from "../lib/api";

export default function ExperienceDetail() {
  const { slug } = useParams();
  const exp = EXPERIENCES.find((x) => x.slug === slug);
  if (!exp) return <Navigate to="/experiences" replace />;
  const others = EXPERIENCES.filter((x) => x.slug !== slug).slice(0, 3);

  return (
    <main>
      <PageHero eyebrow="Signature Experience" title={exp.title} description={exp.tagline} image={exp.image} />
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <div className="img-frame border border-[#C9A55C]/20 p-3">
              <img src={exp.image} alt={exp.title} className="w-full aspect-[4/5] object-cover" />
            </div>
          </Reveal>
          <div>
            <SectionHead eyebrow="The Experience" title={exp.tagline} description={exp.description} />
            <Reveal delay={0.15}>
              <ul className="mt-8 space-y-4">
                {exp.includes.map((inc) => (
                  <li key={inc} className="flex items-center gap-3 text-sm text-[#F3EEE5]/90">
                    <Check size={15} className="text-[#C9A55C] shrink-0" /> {inc}
                  </li>
                ))}
              </ul>
              <div className="mt-10 flex flex-wrap gap-4">
                <Link to="/plan-your-event" onClick={() => track("create_event_click", { location: `experience_${slug}` })} className="btn-gold" data-testid="experience-create-event-btn">
                  Create Your Event
                </Link>
                <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="btn-ghost" data-testid="experience-whatsapp-btn">
                  WhatsApp Our Team
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <section className="py-20 bg-[#0D1018] border-t border-[#C9A55C]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <SectionHead eyebrow="Continue Exploring" title="More Signature Experiences" />
          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {others.map((x) => (
              <Reveal key={x.slug}>
                <Link to={`/experiences/${x.slug}`} className="group block" data-testid={`related-experience-${x.slug}`}>
                  <div className="img-frame aspect-[4/3] border border-[#C9A55C]/15">
                    <img src={x.image} alt={x.title} className="w-full h-full object-cover" loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#070708] to-transparent" />
                    <div className="absolute bottom-0 p-5 flex items-center gap-2">
                      <h3 className="font-display text-lg text-[#F3EEE5] group-hover:text-[#C9A55C] transition-colors">{x.title}</h3>
                      <ArrowRight size={14} className="text-[#C9A55C] opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
